import { SortOrder } from 'src/app/core/interface/sort-order';
import { Page } from "src/app/core/models/page";

export class AutoPrintSettingGetHeaderRequest {
  facility: string | null;
  deliveryTypes: string[] | null;
  docTypes: string[] | null;

  constructor() {
    this.facility = null;
    this.deliveryTypes = null;
    this.docTypes = null;

  }
}
